import { Button, ListItemIcon, MenuItem, MenuList, Popover } from "@mui/material";
import { useMenu } from "../hooks/useMenu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export type ActionItem = {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
};

export const MultipleActionsButton = (props: {
  actionItems: ActionItem[];
  label: string;
  leadingIcon?: React.ReactNode;
}) => {
  const { actionItems, label, leadingIcon } = props;
  const { anchorEl, open, openMenu, closeMenu } = useMenu();
  return (
    <>
      <Button
        variant="outlined"
        endIcon={<ExpandMoreIcon />}
        startIcon={leadingIcon}
        sx={{ fontSize: 14, gap: "8px" }}
        onClick={openMenu}
      >
        {label}
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { mt: "10px", boxShadow: 3 } } }}
      >
        <MenuList>
          {actionItems.map((actionItem) => (
            <MenuItem
              key={actionItem.label}
              onClick={() => {
                closeMenu();
                actionItem.onClick();
              }}
              sx={{ color: "text.primary" }}
            >
              {actionItem.icon && <ListItemIcon sx={{ color: "text.primary" }}>{actionItem.icon}</ListItemIcon>}
              {actionItem.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};
